<template>
    <div class="notification details p-3 w-100 fs-small" :class="{'pointer': propOptions.markAsReadOnClick, 'notificationViewed':notification.markedAsRead == true}">

        <div>
            <!-- title -->
            <div class="titleHolder d-flex flex-row">

                <span class="d-flex flexGrow1 font-weight-600 align-items-center">
                    <span v-html="notification.title" ref="notificatioTitle" class="notificatioTitle"></span>
                    <span v-if="notification.metadata && notification.metadata.labelContent" class="notificationTag lightest radius-stadium px-1 py-0 fs-smallest ml-2 text-uppercase" :class="{'bg-color-1':!notification.metadata.labelColor}" :style="{'background-color':notification.metadata.labelColor}">Pending</span>
                </span>

                <div class="d-flex justify-content-end pr-1 close-btn" v-if="!propOptions.showMarkAsReadDelete" @click="closeNotification(notification)">x</div>

                <div class="markReadDelete dark d-flex" v-if="propOptions.showMarkAsReadDelete">
                    <span v-if="!notification.markedAsRead" class="markRead pointer radius-normal" @click="markRead(notification)">
                        <i class="far fa-circle fs-small mr-2" v-tooltip="{content:'Mark as read', boundariesElement:'window'}"></i>
                    </span>
                    <span v-if="notification.markedAsRead" class="markRead pointer radius-normal" @click="markUnread(notification)">
                        <i class="fas fa-check-circle color-3 fs-small mr-2" v-tooltip="{content:'Mark as unread', boundariesElement:'window'}"></i>
                    </span>
                    <span class="markRead pointer radius-normal" @click="markDeleted(notification, $event)">
                        <i class="far fa-trash-alt fs-small mr-1" v-tooltip="{content:'Delete', boundariesElement:'window'}"></i>
                    </span>
                </div>

            </div>

            <!-- Body -->
            <component v-if="!showBodyBottom" :is="notificationBodyComponent" :notification="notification" @markAsRead="markRead(notification)" @click:stop="notificationClicked" @clicked="notificationClicked"></component>

            <!-- Date -->
            <div class="date dark font-weight-600 fs-smaller pt-1" v-if="notification.date">
                <span>{{notificationDateTime(notification)}}</span>
            </div>

            <!-- Body bottom -->
            <component v-if="showBodyBottom" :is="notificationBodyComponent" :notification="notification" @markAsRead="markRead(notification)"></component>

            <div v-if="notification.metadata && notification.metadata.id" class="d-flex justify-content-end align-items-baseline pr-1 w-100 view-evt">
                <div class="pointer" @click.prevent="viewEventFromNotification">
                    <span class="view-event-link">View Event</span>
                </div>
            </div>
        </div>
        <div class="dark">{{notification.name}}</div>
    </div>
</template>

<script>
import bodySimple from './bodySimple'
import bodyReservationPending from './bodyReservationPending'
import bodyAcceptInvite from './bodyAcceptInvite'
import bodyNewBooking from './bodyNewBooking'
import bodyBookingWithNotes from './bodyBookingWithNotes'
import { calendarEventSelectionMixin } from '@/mixins/calendarEventSelection'
import { mapActions, mapGetters } from 'vuex'
export default {
    mixins: [calendarEventSelectionMixin],
    data: function() {
        return {
            notificationOptions: {
                markAsReadOnClick: false,
                showMarkAsReadDelete: true,
            }
        }
    },
    props: {
        notification: {
            type: Object
        },
        options:{
            type: Object,
            required: false
        }
    },
    mounted() {
        this.addClickEventsToTitle()
        // Parse metadata string to JSON
        if(this.notification.metadata && this.notification.metadata[0] == "{"){
            this.notification.metadata = JSON.parse(this.notification.metadata)
        }
    },
    methods: {
        ...mapActions([
            'markNotificationAsRead',
            'markNotificationAsUnread',
            'deleteNotification',
            'openUnkownAgent',
            'downloadSingleEvent',
            'updateSidebar',
            'updateSelectedEvent',
            'downloadGenderPricePerChannel',
            'toggleBellNotificationPopup'
        ]),
        markRead: function(notification) {
            this.closeNotification();
            this.markNotificationAsRead(notification)
        },
        markUnread: function(notification) {
            this.$emit('markedAsUnread', notification)
            this.markNotificationAsUnread(notification)
        },
        markDeleted: function(notification, e) {
            this.$emit('deleteNotification', notification)
            this.deleteNotification(notification)
        },
        addClickEventsToTitle: function () {
            let vm = this
            let elements = this.$refs['notificatioTitle'].children;

            for (var i = 0, len = elements.length; i < len; i++) {
                // Agent name
                var agentName = elements[i].hasAttribute('prop');
                if(agentName){
                    elements[i].addEventListener('click', function(event) {
                        vm.agentNameClicked()
                    })
                }

            }

        },
        viewEventFromNotification: async function () {
            this.toggleBellNotificationPopup(false)
            await this.selectEventInCalendar(this.notification.metadata.id)
            this.closeNotification()
        },
        agentNameClicked: function () {
            this.openUnkownAgent({
                agentId: this.notification.metadata.agent.id
            })
        },
        notificationClicked: function () {
            if(this.propOptions.markAsReadOnClick){
                this.markRead(this.notification)
            }

            this.closeNotification();
        },
        notificationDateTime: function (notification) {
            return this.formatDateDots(notification.date)+' '+this.formatTime(notification.date)
        },
        closeNotification: function () {
            this.$emit('closeNotification', this.notification);
        },
    },
    computed: {
        ...mapGetters([
            'getSelectedEvent',
        ]),
        propOptions: function () {
            Object.assign(this.notificationOptions, this.options)
            return this.notificationOptions
        },
        notificationBodyComponent: function () {

            switch (this.notification.type) {
                case -1:
                    return 'bodyNewBooking'
                    break;
                case 3:
                    if(this.notification.typeStatus == 301){
                        return 'bodyBookingWithNotes'
                    } else {
                        return 'bodyReservationPending'
                    }
                    break;
                case 4:
                    return 'bodyAcceptInvite'
                    break;
                default:
                    return 'bodySimple'
            }
        },
        showBodyBottom: function () {
            return this.notification.type == 4
        }
    },
    components: {
        bodySimple,
        bodyReservationPending,
        bodyAcceptInvite,
        bodyNewBooking,
        bodyBookingWithNotes
    }
}
</script>

<style lang="scss">
    @import '../../../assets/scss/_variables.scss';
    @import '../../../assets/scss/_typography.scss';
    .notificatioTitle{
        // background: red;
        b {
            // background: blue !important;
            @extend .font-weight-700;
        }

        span[prop]{
            cursor: pointer;

            &:hover{
                text-decoration: underline;
            }
        }
    }
</style>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';
    @import '../../../assets/scss/_typography.scss';

    .notification {
        background: $lighter;

        &.notificationViewed {
            background: $lightest;
        }

        .titleHolder {
            line-height: 1rem;
            color: $darkest;

            .notificationTag {
                height: 1rem;
            }

            .markReadDelete {
                height: 1rem;
                text-align: center;
            }
        }

        .markRead {
            right: 0;
            top: 0;
        }
    }

    .close-btn {
        font-size: 1.2rem;
        font-weight: 400;
        line-height: 1;
        color: #c5d0de;
        text-shadow: none;
    }

    .view-evt { 
        margin-top: 0.25rem;
        z-index: 2; 
    }

    .view-event-link {
        font-size: 0.625rem;
        color: #222c3c;
    }
</style>



// WEBPACK FOOTER //
// default.vue?04ca908a